export default "__VITE_ASSET__C1RfrI3H__"